import type { TypedDocumentNode } from '@apollo/client';
import { gql, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import type {
  CreateUserPortfolioFilterMutationPayload,
  MutationCreateUserPortfolioFilterArgs,
} from '@/types/GraphqlSchema';

const CREATE_USER_PORTFOLIO_FILTER_MUTATION: TypedDocumentNode<
  { createUserPortfolioFilter: CreateUserPortfolioFilterMutationPayload },
  MutationCreateUserPortfolioFilterArgs
> = gql`
  mutation CreateUserPortfolioFilter(
    $assets: [JSON!]
    $basins: [JSON!]
    $countries: [JSON!]
    $companies: [JSON!]
    $developmentStatuses: [JSON!]
    $npvMax: Float
    $npvMin: Float
    $operator: Boolean
    $opportunities: Boolean
    $productionMax: Float
    $productionMin: Float
    $reservesMax: Float
    $reservesMin: Float
    $resourceThemes: [JSON!]
    $shoreStatuses: [JSON!]
  ) {
    createUserPortfolioFilter(
      assets: $assets
      basins: $basins
      countries: $countries
      companies: $companies
      developmentStatuses: $developmentStatuses
      npvMax: $npvMax
      npvMin: $npvMin
      operator: $operator
      opportunities: $opportunities
      productionMax: $productionMax
      productionMin: $productionMin
      reservesMax: $reservesMax
      reservesMin: $reservesMin
      resourceThemes: $resourceThemes
      shoreStatuses: $shoreStatuses
    ) {
      userPortfolioFilter {
        id
        uuid
        userId
        filters {
          assets
          basins
          countries
          companies
          developmentStatuses
          npvMax
          npvMin
          operator
          opportunities
          productionMax
          productionMin
          reservesMax
          reservesMin
          resourceThemes
          shoreStatuses
        }
        createdAt
        updatedAt
      }
      errors
    }
  }
`;

export const useSavePortfolioBridge = () => {
  const [createUserPortfolioFilterMutation, { loading, error }] = useMutation(
    CREATE_USER_PORTFOLIO_FILTER_MUTATION,
  );

  const savePortfolioBridge = useCallback(
    async (filters: MutationCreateUserPortfolioFilterArgs): Promise<string | null> => {
      try {
        const result = await createUserPortfolioFilterMutation({
          variables: filters,
        });

        if (result.data?.createUserPortfolioFilter?.errors?.length) {
          console.error(
            'Failed to save portfolio bridge:',
            result.data.createUserPortfolioFilter.errors,
          );
          return null;
        }

        return result.data?.createUserPortfolioFilter?.userPortfolioFilter?.uuid || null;
      } catch (err) {
        console.error('Error saving portfolio bridge:', err);
        return null;
      }
    },
    [createUserPortfolioFilterMutation],
  );

  return {
    savePortfolioBridge,
    loading,
    error,
  };
};
